export default __webpack_public_path__ + "static/2-3764491de4f0a65970a629d062ca9c96.png";